<template>
  <div>
    <base-navbar />
    <div class="sidabar bd-right container-fluid pt-3">
      <base-sidebar />
    </div>
    <div class="main-content pt-4">
      <div class="container-fluid">
        <dashboard-core></dashboard-core>
      </div>
    </div>
  </div>
</template>

<script>
import DashboardCore from '@/views/dashboard/layout/DashboardCore';
import BaseSidebar from '@/components/sidebar/BaseSidebar';
import BaseNavbar from '@/components/navbar/BaseNavbar';
export default {
  components: {
    BaseSidebar,
    BaseNavbar,
    DashboardCore
  }
}
</script>

<style>

</style>